__turbopack_context__.v({
  "banner": "ItineraryCardInfoBanner-module__HbZHmq__banner",
  "error": "ItineraryCardInfoBanner-module__HbZHmq__error",
  "filled": "ItineraryCardInfoBanner-module__HbZHmq__filled",
  "icon": "ItineraryCardInfoBanner-module__HbZHmq__icon",
  "text": "ItineraryCardInfoBanner-module__HbZHmq__text",
});
